import { motion } from "motion/react";
import { MessageCircleQuestion } from "lucide-react";
import { useChat } from "./ChatContext";

export function AskAboutButton({
    subject,
    language = "fr",
    color = "#22d3ee",
    section = "project",
    context,
}: {
    subject: string;
    language?: string;
    color?: string;
    section?: "project" | "experience" | "education" | "publication";
    context?: string;
}) {
    const { askAbout } = useChat();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();

        const prompts: Record<string, Record<string, string>> = {
            project: {
                fr: `Parle-moi du projet "${subject}".`,
                en: `Tell me about the project "${subject}".`,
            },
            experience: {
                fr: `Parle-moi de cette expérience : "${subject}".`,
                en: `Tell me about this experience: "${subject}".`,
            },
            education: {
                fr: `Parle-moi de cette formation : "${subject}".`,
                en: `Tell me about this education: "${subject}".`,
            },
            publication: {
                fr: `Parle-moi de cette publication : "${subject}".`,
                en: `Tell me about this publication: "${subject}".`,
            },
        };

        const lang = language === "en" ? "en" : "fr";
        askAbout(prompts[section][lang], context);
    };

    return (
        <motion.button
            onClick={handleClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full transition-all"
            style={{
                background: `${color}12`,
                border: `1px solid ${color}30`,
                color: color,
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                cursor: "none",
                whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = `${color}25`;
                e.currentTarget.style.borderColor = `${color}50`;
                e.currentTarget.style.boxShadow = `0 0 12px ${color}30`;
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = `${color}12`;
                e.currentTarget.style.borderColor = `${color}30`;
                e.currentTarget.style.boxShadow = "none";
            }}
        >
            <MessageCircleQuestion size={13} />
            <span>{language === "en" ? "Ask about this" : "En savoir plus"}</span>
        </motion.button>
    );
}
